// src/components/UserMenu.jsx - Update to include workout link
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useAuth } from "../contexts/AuthContext";
import { User, LogOut, History, UserCircle, Database, Utensils, Dumbbell } from "lucide-react"; // Add Dumbbell
import { useToast } from "./ui/use-toast";
import { useNavigate } from "react-router-dom";
import { usdaService } from '../services/usdaService';

export const UserMenu = () => {
  const { user, signOut } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      // Navigate first
      navigate('/');
      // Then sign out
      await signOut();
      toast({
        title: "Signed out successfully",
        description: "You have been signed out of your account.",
      });
    } catch (error) {
      console.error('Error signing out:', error);
      toast({
        title: "Sign out error",
        description: "There was a problem signing out. Please try again.",
        variant: "destructive",
      });
    }
  };

  const handleClearCache = async () => {
    try {
      await usdaService.clearCache();
      toast({
        title: "Cache Cleared",
        description: "Food search cache has been cleared successfully."
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to clear cache. Please try again.",
        variant: "destructive"
      });
    }
  };

  if (!user) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <User className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <div className="px-2 py-1.5">
          <p className="text-sm font-medium">Signed in as:</p>
          <p className="text-xs text-muted-foreground truncate">{user.email}</p>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem 
          onClick={() => navigate('/profile')}
          className="cursor-pointer"
        >
          {/* User Profile */}
          <UserCircle className="mr-2 h-4 w-4" />
          Profile
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => navigate('/history')}
          className="cursor-pointer"
        >
          {/* history logged */}
          <History className="mr-2 h-4 w-4" />
          History
        </DropdownMenuItem>
        <DropdownMenuSeparator />

        {/* food logger */}
        {/* <DropdownMenuItem onClick={() => navigate('/food-logger')}>
          <Utensils className="mr-2 h-4 w-4" />
          Food Logger
        </DropdownMenuItem> */} {/* commenting out for now. This will be the last phase of the web app now. */}
        
        {/* workout tracker */}
        <DropdownMenuItem onClick={() => navigate('/workouts')}>
          <Dumbbell className="mr-2 h-4 w-4" />
          Workout Tracker
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        
        <DropdownMenuItem 
          onClick={handleSignOut}
          className="cursor-pointer text-red-600 dark:text-red-400"
        >
          <LogOut className="mr-2 h-4 w-4" />
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};